/**
 * How long a list stays in memory after the last page that read it closes,
 * and how old it may be before the next page to open it asks again. Coming
 * back to Tasks, Inbox or Sequences shows the rows it had and refreshes them
 * behind, instead of starting from a blank list after the 60s default.
 */
export const LIST_KEEP_SECONDS = 600;
export const LIST_REVALIDATE_SECONDS = 30;
